<div cdkDrag cdkDragRootElement=".ant-modal-content">
  <div *nzModalTitle class="inline" cdkDragHandle>
    Upload Files
    <div class="actions">
      <nz-icon
        nzType="shrink"
        nzTheme="outline"
        class="button"
        (click)="modal.toggle()"
        *ngIf="!modal.minimized"
      />
      <nz-icon
        nzType="arrows-alt"
        nzTheme="outline"
        class="button"
        (click)="modal.toggle()"
        *ngIf="modal.minimized"
      />
      <nz-icon
        nzType="close-circle"
        (click)="modal.destroy()"
        class="button cancel"
        nzTheme="outline"
      />
    </div>
  </div>

  <div style="margin-bottom: -16px">
    <app-upload-files
      #UploadFiles
      [source_name]="nzData.source_name"
      [source_id]="nzData.source_id"
      [files]="nzData.files || []"
      (isProcessing)="isProcessing = $event"
      (countFiles)="countFiles = $event"
      (completed)="modal.destroy($event)"
    />
  </div>

  <div *nzModalFooter cdkDragHandle style="height: 32px">
    <button
      nz-button
      nzType="default"
      (click)="modal.destroy()"
      [disabled]="isProcessing"
    >
      Close
    </button>
    <button
      nz-button
      nzType="primary"
      (click)="UploadFiles.upload()"
      [disabled]="!countFiles"
      [nzLoading]="isProcessing"
    >
      Submit and Close
    </button>
  </div>
</div>
